module.exports = __webpack_public_path__ + "static/media/djeeta-win.a6cfc343.png";